import type { AppCustomEvent, AppEventDetailMap } from "./types";

/**
 * CustomEventの発火ヘルパー
 */
export function emitEvent<T extends keyof AppEventDetailMap>(
  eventType: T,
  detail: AppEventDetailMap[T],
): void;
export function emitEvent<T extends keyof AppEventDetailMap>(
  eventType: T,
  detail?: AppEventDetailMap[T],
): void {
  if (typeof window === "undefined") {
    return;
  }

  const event =
    detail !== undefined
      ? new CustomEvent(eventType, { detail })
      : new CustomEvent(eventType);

  window.dispatchEvent(event);
}

/**
 *　イベントリスナー登録ヘルパー
 */
export function addEventListener<T extends keyof AppEventDetailMap>(
  eventType: T,
  listener: (event: AppCustomEvent<T>) => void,
): void {
  if (typeof window === "undefined") {
    return;
  }

  window.addEventListener(eventType, listener as EventListener);
}
